<ng-container *transloco="let t;">
    <div class="modal-header">
        <h4 class="modal-title" id="myModalLabel1">{{ t('Contract control index data title (Contract control index data
            modal) - Show index data') }}</h4>
        <button type="button" class="close" aria-label="Close" (click)="closeModal()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body py-0 px-0" tabindex="0" ngbAutofocus>
        <app-skeleton *ngIf="!isDataloaded" [loop]="9" [section]="'index_data_model_skeleton'"></app-skeleton>
        <ng-scrollbar autoHeightDisabled="false" visibility="hover">
            <div *ngIf="isDataloaded" class="CC_indexDataScrollCont CC_indexDataContainer">
                <div class="table-responsive ">
                    <table class="table">
                        <thead>
                            <tr>
                                <th colspan="2">{{ t('Contract control index data contract details container title
                                    (Contract control index data modal) - Contract Details') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{{ t('Contract control index data contract details container field name (Contract
                                    control index data modal) - Name') }}</td>
                                <td>{{ indexData.contract_control_name }}</td>
                            </tr>
                            <tr>
                                <td>{{ t('Contract control index data contract details container field name (Contract
                                    control index data modal) - Document type') }}</td>
                                <td>{{ indexData?.document_type?.document_type }}</td>
                            </tr>
                            <tr>
                                <td>{{ t('Contract control index data contract details container field name (Contract
                                    control index data modal) - Category') }}</td>
                                <td>{{ indexData?.category?.category_name }}</td>
                            </tr>
                            <tr>
                                <td>{{ t('Contract control index data contract details container field name (Contract
                                    control index data modal) - Contract number') }}</td>
                                <td>{{ indexData?.contract_no }}</td>
                            </tr>
                            <tr>
                                <td>{{ t('Contract control index data contract details container field name (Contract
                                    control index data modal) - Level') }}</td>
                                <td>{{ indexData?.contract_type === 1 ? 'Master' : 'Sub'}} Contract</td>
                            </tr>
                            <tr *ngIf="indexData?.contract_type === 1 && indexData?.sub_contracts.length">
                                <td>{{ t('Contract control index data contract details container field name (Contract
                                    control index data modal) - Sub contracts') }}</td>
                                <td>
                                    <span>{{ indexData?.sub_contracts | arrayToString : ',':
                                        getContractNameColumnFromObject }}</span>
                                </td>
                            </tr>
                            <tr *ngIf="indexData?.contract_type === 2 && indexData?.master_contract">
                                <td>{{ t('Contract control index data contract details container field name (Contract control index data modal) - Belongs to') }}</td>
                                <td>
                                    <span>{{ indexData?.master_contract?.contract_control_name }}</span>
                                </td>
                            </tr>
                            <tr>
                                <td>{{ t('Contract control index data contract details container field name (Contract control index data modal) - Created') }}</td>
                                <td>{{ indexData?.created_at | date: 'mediumDate' }}</td>
                            </tr>
                            <tr>
                                <td>{{ t('Contract control index data contract details container field name (Contract control index data modal) - Status') }}</td>
                                <td>{{ indexData?.is_active === 1 ? t('Contract status - (Contract control section) - Active') : t('Contract status - (Contract control section) - Inactive') }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                @if(indexData?.document_type?.document_type_data?.document_type_custom_boxes){
                @for(customBox of indexData?.document_type?.document_type_data?.document_type_custom_boxes; track
                customBox; let index = $index){
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th colspan="2">{{ customBox.name }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for(customBoxData of customBox.document_type_custom_boxes_data; track customBoxData){
                            <tr>
                                <td>{{ customBoxData.meta_data.meta_data_name }}</td>
                                <td>{{ (customBoxData?.contract_control_custom_boxes_data?.value &&
                                    customBoxData?.contract_control_custom_boxes_data?.value !== 0 ?
                                    customBoxData?.contract_control_custom_boxes_data?.value : '')}}</td>
                            </tr>
                            }
                        </tbody>
                    </table>
                </div>
                }
                }

                @if(indexData?.contacts.length){
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th colspan="2">{{ t('Contract control general box label - (Contract control section) - Contacts') }}</th>
                            </tr>
                        </thead>
                        @for(contact of indexData?.contacts; track contact; let index = $index){
                        <tbody>
                            <tr>
                                <td class="paddingleft25"><b>({{ index + 1 }})</b> {{ t('Full name (general) - Full name') }}</td>
                                <td>{{ contact.sectionable?.firstname + ' ' + contact.sectionable?.lastname }}</td>
                            </tr>
                            <tr>
                                <td class="paddingForPadding">{{ t('Email (general) - Email') }}</td>
                                <td>{{ contact?.sectionable?.email }}</td>
                            </tr>
                            <tr>
                                <td class="paddingForPadding">{{ t('Phone (general) - Phone') }}</td>
                                <td>{{ contact?.sectionable?.phone_no ?? '-' }}</td>
                            </tr>
                            <tr>
                                <td class="paddingForPadding">{{ t('Address (general) - Address') }}</td>
                                <td>{{ contact?.sectionable?.address ?? '-' }}</td>
                            </tr>

                            <tr>
                                <td class="paddingForPadding">{{ t('Zip code (general) - Zip code') }}</td>
                                <td>{{ contact?.sectionable?.zipcode ?? '-' }}</td>
                            </tr>

                            <tr>
                                <td class="paddingForPadding">{{ t('City (general) - City') }}</td>
                                <td>{{ contact?.sectionable?.city ?? '-' }}</td>
                            </tr>

                            <tr>
                                <td class="paddingForPadding">{{ t('Personal ID number (general) - Personal ID number') }}</td>
                                <td>{{ contact?.sectionable?.persnol_no ?? '-' }}</td>
                            </tr>

                            <tr>
                                <td class="paddingForPadding">{{ t('Organization (general) - Organization') }}</td>
                                <td>{{ contact?.sectionable?.organization?.name ?? '-' }}</td>
                            </tr>
                        </tbody>
                        }
                    </table>
                </div>
                }

                @if(indexData?.managers.length){
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th colspan="2">{{ t('Contract control general box label - (Contract control section) - Manager') }}</th>
                            </tr>
                        </thead>
                        @for(manager of indexData?.managers; track manager; let index = $index){
                        <tbody>
                            <tr>
                                <td class="paddingleft25"><b>({{ index + 1 }})</b> {{ t('Full name (general) - Full name') }}</td>
                                <td>{{ manager.sectionable?.name }}</td>
                            </tr>
                            <tr>
                                <td class="paddingForPadding">{{ t('Email (general) - Email') }}</td>
                                <td>{{ manager?.sectionable?.email }}</td>
                            </tr>
                        </tbody>
                        }
                    </table>
                </div>
                }

                <div class="table-responsive" *ngIf="indexData?.related_contract.length">
                    <table class="table">
                        <thead>
                            <tr>
                                <th colspan="2">{{ t('Contract control general box label - (Contract control section) - Related Contracts') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for(contract of indexData?.related_contract; track contract){
                            <tr>
                                <td class="paddingleft25">{{ t('Name (general) - Name') }}</td>
                                <td>{{ contract?.contract_control?.contract_control_name }}</td>
                            </tr>
                            }
                        </tbody>
                    </table>
                </div>


                <div class="table-responsive" *ngIf="indexData?.organization">
                    <table class="table">
                        <thead>
                            <tr>
                                <th colspan="2">{{ t('Organization (general) - Organization') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{{ t('Name field title (Organization modal) - Name') }}</td>
                                <td>{{ indexData?.organization.name }}</td>
                            </tr>
                            <tr>
                                <td>{{ t('Reg no field title (Organization modal) - Reg no') }}</td>
                                <td>{{ indexData?.organization.register_no }}</td>
                            </tr>
                            <tr>
                                <td>{{ t('Address field title (Organization modal) - Address') }}</td>
                                <td>{{ indexData?.organization.address }}</td>
                            </tr>
                            <tr>
                                <td>{{ t('Phone number field title (Organization modal) - Phone number') }} </td>
                                <td>{{ indexData?.organization.phone }}</td>
                            </tr>
                            <tr>
                                <td>{{ t('Zip code field title (Organization modal) - Zip code') }}</td>
                                <td>{{ indexData?.organization.zipcode }}</td>
                            </tr>
                            <tr>
                                <td>{{ t('City field title (Organization modal) - City') }}</td>
                                <td>{{ indexData?.organization.city }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="table-responsive" *ngIf="indexData?.period_renewal">
                    <table class="table">
                        <thead>
                            <tr>
                                <th colspan="2">{{ t('Contract control general box label - (Contract control section) - Period and renewal') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{{ t('Period and renewal card field title - (Contract control section) - Start date') }}</td>
                                <td>{{ indexData?.period_renewal.start_date }}</td>
                            </tr>
                            <tr>
                                <td>{{ t('Period and renewal card field title - (Contract control section) - End date') }}</td>
                                <td>{{ indexData?.period_renewal.end_date }}</td>
                            </tr>
                            <tr>
                                <td>{{ t('Period and renewal card field title - (Contract control section) - Notice period') }}</td>
                                <td>{{ indexData?.period_renewal.notice }} {{ indexData?.period_renewal?.notice_period
                                    === 'd' ? 'day' : 'month' }}{{ indexData?.period_renewal?.notice > 1 ? '(s)' : ''}}
                                </td>
                            </tr>
                            <tr>
                                <td>{{ t('Period and renewal card field title - (Contract control section) - Auto renewal') }}</td>
                                <td>{{ indexData?.period_renewal?.auto_renew === 1 ? 'Yes' : 'No' }}</td>
                            </tr>
                            <tr>
                                <td>{{ t('Period and renewal card field title - (Contract control section) - Contract length after renewal') }}</td>
                                <td>{{ contractLengths[indexData?.period_renewal?.contract_length_renew] ?? '-' }}</td>
                            </tr>
                            <tr>
                                <td>{{ t('Period and renewal card field title - (Contract control section) - Notice period after renewal') }}</td>
                                <td>{{ indexData?.period_renewal?.notice_renew }} {{
                                    indexData?.period_renewal?.notice_period_renew === 'd' ? 'day' : 'month' }} {{
                                    indexData?.period_renewal?.notice_renew > 1 ? '(s)' : '' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="table-responsive costPreviewCard-wrapper" *ngIf="indexData?.costs?.length">
                    <div class="table-title">
                        <h5 class="table-h5">{{ t('Contract control general box label - (Contract control section) - Cost') }}</h5>
                    </div>
                    <table class="table table-hover table-striped">
                        <thead>
                            <tr>
                                <th class="col-width">{{ t('Contract control box field title (Contract control section) - Description') }}</th>
                                <th>{{ t('Contract control box field title (Contract control section) - Billing start date') }}</th>
                                <th>{{ t('Contract control box field title (Contract control section) - Billing end date') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for(cost of indexData?.costs; track cost) {
                                <tr>
                                    <td class="col-width">
                                        <span class="cost_description">{{ cost.description ?? '' }}</span>
                                        <div>
                                            <span class="cost_amount">{{ cost.cost_amount }} {{ cost.cost_currency }}</span> / <span class="cost_billing_frequency" placement="auto" triggers="hover" ngbTooltip="Billing frequency">{{ cost.billing_frequency_label }}</span>
                                        </div>
                                    </td>
                                    <td><span class="hover-effect">{{ cost.billing_start | dateFormat | async }}</span></td>
                                    @if(cost.billing_end == null) {
                                        <td><span placement="auto" triggers="hover" class="hover-effect" ngbTooltip="Click to add end date">-</span></td>
                                    } @else {
                                        <td><span class="hover-effect">{{ cost.billing_end | dateFormat | async }}</span></td>
                                    }
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>

                 <div class="table-responsive costPreviewCard-wrapper" *ngIf="indexData?.revenues?.length">
                    <div class="table-title">
                        <h5 class="table-h5">{{ t('Contract control general box label - (Contract control section) - Revenue') }}</h5>
                    </div>
                    <table class="table table-hover table-striped">
                        <thead>
                            <tr>
                                <th class="col-width">{{ t('Contract control box field title (Contract control section) - Description') }}</th>
                                <th>{{ t('Contract control box field title (Contract control section) - Billing start date') }}</th>
                                <th>{{ t('Contract control box field title (Contract control section) - Billing end date') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for(revenue of indexData?.revenues; track revenue) {
                                <tr>
                                    <td class="col-width">
                                        <span class="revenue_description">{{ revenue.description ?? '' }}</span>
                                        <div>
                                            <span class="revenue_amount">{{ revenue.revenue_amount }} {{ revenue.revenue_currency }}</span> / <span class="revenue_billing_frequency" placement="auto" triggers="hover" ngbTooltip="Billing frequency">{{ revenue.billing_frequency_label }}</span>
                                        </div>
                                    </td>
                                    <td><span class="hover-effect">{{ revenue.billing_start | dateFormat | async }}</span></td>
                                    @if(revenue.billing_end == null) {
                                        <td><span placement="auto" triggers="hover" class="hover-effect" ngbTooltip="Click to add end date">-</span></td>
                                    } @else {
                                        <td><span class="hover-effect">{{ revenue.billing_end | dateFormat | async }}</span></td>
                                    }
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>


                <div class="table-responsive" *ngIf="indexData?.todo.length">
                    <table class="table">
                        <thead>
                            <tr>
                                <th colspan="2">{{ t('Contract control general box label - (Contract control section) - Task') }}</th>
                            </tr>
                        </thead>
                        @for(todo of indexData?.todo; track todo; let index = $index){
                        <tbody>
                            <tr>
                                <td class="paddingleft25"><b>({{index + 1}})</b> {{ t('Contract control index data task container field name (Contract control index data modal) - Message') }}</td>
                                <td>{{ todo.description }}</td>
                            </tr>
                            <tr>
                                <td class="paddingForPadding">{{ t('Contract control index data task container field name (Contract control index data modal) - Date') }}</td>
                                <td>{{ todo?.due_date }}</td>
                            </tr>
                        </tbody>
                        }
                    </table>
                </div>
            </div>
        </ng-scrollbar>
    </div>
</ng-container>
